export enum DataType {
Integer,
Numeric,
String,
Logic,
DateTime,
Date,
Time,
Money,
ListValue,
Entity,
Duration,
}
